export default __webpack_public_path__ + "static/media/bg_history_order.af2aff29.svg";